import React, { type FC } from 'react';
import { ToolNavigationItem } from './ToolNavigationItem';
import { PrimaryNavigationItem } from '../types';
import classes from '../styles/index.module.css';
import { useTranslationAPI } from '../../translations';

type ToolNavigationListProps = {
	items: PrimaryNavigationItem[];
	dataTestId?: string;
};

export const ToolNavigationList: FC<ToolNavigationListProps> = ({ items, dataTestId }) => {
	const { translate } = useTranslationAPI();

	return (
		<div
			className={classes.toolNavigation__list}
			data-testid={dataTestId}
		>
			{items.map((item) => (
				<ToolNavigationItem
					key={item.pageTypeId}
					title={translate(item.titleCode)}
					icon={item.icon}
					url={item.url}
					childNavigationItems={item.childNavigationItems}
					pageTypeId={item.pageTypeId}
				/>
			))}
		</div>
	);
};
